import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  Switch,
  FormControlLabel,
  FormGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import BASE_URL from "../../utils/baseUrl";

export default function UserDataList() {
  const token = localStorage.getItem("authToken");
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [formData, setFormData] = React.useState({
    selfHelpGroup: "",
    name: "",
    language: "",
    location: "",
    isMaternity: false,
    designation: "",
    hwc: "",
  });

  React.useEffect(() => {
    getUserDataList();
  }, []);

  const getUserDataList = () => {
    axios
      .get(`${BASE_URL}/userData/list`, {
        headers: {
          token: token,
        },
      })
      .then((_data) => {
        console.log("data", _data.data);
        const formattedData = _data.data.map((item) => ({
          ...item,
          formattedCreatedAt: item.createdAt
            ? new Date(item.createdAt._seconds * 1000).toLocaleString()
            : "NA",
          updatedAt: item.updatedAt
            ? new Date(item.updatedAt._seconds * 1000).toLocaleString()
            : "NA",
          // isMultiple: item.isMultiple ? "Yes" : "No",
        }));
        console.log("FORMATED DATA::", formattedData);
        setRows(formattedData);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (editMode) {
      // Edit mode: PUT/PATCH request
      const url = `${BASE_URL}/userData/${selectedId}`; // Assuming this is the endpoint for editing
      try {
        await axios.put(url, formData, {
          headers: {
            token: token,
          },
        });
        // Handle successful edit
        console.log("Edited successfully");
      } catch (error) {
        console.error("There was an error updating the data:", error);
      }
    } else {
      // Add mode: POST request
      const url = `${BASE_URL}/userData/list`;
      try {
        await axios.post(url, formData, {
          headers: {
            token: token,
          },
        });
        // Handle successful add
        console.log("Added successfully");
      } catch (error) {
        console.error("There was an error submitting the form:", error);
      }
    }
    handleClose(); // Close the dialog
    getUserDataList(); // Refresh the list
  };
  const handleDelete = async () => {
    const url = `${BASE_URL}/userData/${deleteId}`; // Assuming this is your endpoint for deletion
    try {
      await axios.delete(url, {
        headers: {
          token: token,
        },
      });
      // Handle successful deletion
      console.log("Deleted successfully");
      handleDeleteDialogClose(); // Close the confirmation dialog
      getUserDataList(); // Refresh the list
    } catch (error) {
      console.error("There was an error deleting the entry:", error);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 200 },
    { field: "selfHelpGroup", headerName: "Self Help Group", width: 130 },
    { field: "name", headerName: "Name", width: 130 },
    { field: "language", headerName: "Language", width: 130 },
    { field: "location", headerName: "Location", width: 130 },
    {
      field: "isMaternity",
      headerName: "Is Maternity",
      width: 130,
      type: "boolean",
    },
    { field: "designation", headerName: "Designation", width: 130 },
    { field: "hwc", headerName: "HWC", width: 130 },
    {
      field: "formattedCreatedAt",
      headerName: "Created At",
      width: 120,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 120,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 130,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleEditClick(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => handleDeleteClickOpen(params.id)}>
            <DeleteIcon />
          </IconButton>
        </>
      ),
      sortable: false,
      filterable: false,
    },
  ];
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditMode(false); // Reset edit mode
    setSelectedId(null); // Reset selected ID
    // Reset form data to default
    setFormData({
      selfHelpGroup: "",
      name: "",
      language: "",
      location: "",
      isMaternity: false,
      designation: "",
      hwc: "",
    });
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleEditClick = (row) => {
    setFormData({
      selfHelpGroup: row.selfHelpGroup,
      name: row.name,
      language: row.language,
      location: row.location,
      isMaternity: row.isMaternity,
      designation: row.designation,
      hwc: row.hwc,
    });
    setSelectedId(row.id); // Store the selected row's ID
    setEditMode(true); // Set the mode to edit
    setOpen(true);
  };

  const handleDeleteClickOpen = (id) => {
    setOpenDeleteDialog(true);
    setDeleteId(id); // Set the ID to delete
  };
  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <div style={{ height: 400, width: "100%" }}>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: "10px" }}
        onClick={handleClickOpen}
      >
        Add New
      </Button>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add New User</DialogTitle>
        <DialogContent>
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <TextField
              label="Self Help Group"
              variant="outlined"
              name="selfHelpGroup"
              value={formData.selfHelpGroup}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Name"
              variant="outlined"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Language"
              variant="outlined"
              name="language"
              value={formData.language}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Location"
              variant="outlined"
              name="location"
              value={formData.location}
              onChange={handleChange}
              fullWidth
            />
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isMaternity}
                    onChange={handleChange}
                    name="isMaternity"
                  />
                }
                label="Is Maternity"
              />
            </FormGroup>
            <TextField
              label="Designation"
              variant="outlined"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="HWC"
              variant="outlined"
              name="hwc"
              value={formData.hwc}
              onChange={handleChange}
              fullWidth
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* delete dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this item?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
